import ky from 'ky';
import session from 'auth/session';

// Same-origin: the deployment's auth edge serves the API under /api/* on the SPA's
// own host. That is what lets the __Host-Session cookie reach it at all, and it is
// also what makes writes pass — the backend's CSRF check demands
// Sec-Fetch-Site: same-origin, so a cross-origin call to the API host is a 403.
const original = ky.create({
  prefix: '/api',
  credentials: 'same-origin',
});

const API_PREFIX = '/api';

// Both, and they are not redundant. The header is the selector — it tells the edge
// which org slot this tab is acting as, and org is per-tab. The path says which org
// the URL was written for, so it survives being copied out of the tab: pasted into
// the address bar, opened as a download, or fetched by the browser itself as an
// <img src>, none of which can carry a header.
export async function nameTheOrg({ request }: { request: Request }): Promise<Request | undefined> {
  const org = session.org?.orgSlug;
  for (const [name, value] of Object.entries(session.orgHeader())) {
    request.headers.set(name, value);
  }
  if (!org) return;
  const url = new URL(request.url);
  if (!url.pathname.startsWith(`${API_PREFIX}/`)) return;
  url.pathname = `${API_PREFIX}/orgs/${encodeURIComponent(org)}${url.pathname.slice(API_PREFIX.length)}`;
  // Spelled out rather than `new Request(url, request)`: whether a Request used as init
  // contributes its method and body is a browser/undici difference, and what that
  // produces is a POST silently sent as a GET. `signal` carries ky's timeout.
  return new Request(url, {
    method: request.method,
    headers: request.headers,
    body: request.body ? await request.arrayBuffer() : undefined,
    credentials: request.credentials,
    signal: request.signal,
  });
}

const extended = original.extend({
  hooks: {
    beforeRequest: [nameTheOrg],
    afterResponse: [
      ({ response }) => {
        session.handle(response);
        return response;
      },
    ],
  },
});

export default extended;
